import React from "react";
import { useSelector } from "react-redux";
import { string } from "prop-types";
import get from "lodash/get";

import { Button } from "../../atoms";
import { STATIC_KEYWORDS } from "../../../constants";

import "./GoAdFreeWidgetRed.m.css";

const GoAdFreeWidgetRed = ({ customStyleName, isStorypage = false }) => {
  const { GO_AD_FREE, GO_AD_FREE_BLACK_DESCRIPTION_SIGN_UP, GO_AD_FREE_BLACK_DESCRIPTION_ENJOY } = STATIC_KEYWORDS;
  const qtConfig = useSelector((state) => get(state, ["qt", "config"], {}));
  const isAdfreePage = get(qtConfig, ["subscriber"]) === "true";
  const enableSubscription = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "enable_subscription"], true)
  );
  const isWebView = get(qtConfig, ["isWebView"]) === true;

  if (!enableSubscription || isWebView) return null;

  return isAdfreePage ? null : (
    <div styleName={`go-ad-free-container ${customStyleName} ${isStorypage ? 'story-ad-free-container' : ''}`}>
      <a customStyleName="go-ad-free-btn-red" aria-label="go to ad free for Fortune India" href="/subscription">
        {isStorypage && <div styleName="logo-button">
          <div styleName="fortune-logo"></div>
          <div styleName="button-wrapper">
            <Button customStyleName="go-ad-free-btn-red" aria-label="go to ad free for Fortune India" href="/subscription">
              {GO_AD_FREE}
            </Button>
          </div>
        </div>}
        <div styleName="content-wrapper">
          <div styleName="content-div">
            <div styleName="go-ad-free-text">{GO_AD_FREE_BLACK_DESCRIPTION_SIGN_UP}</div>
            <span>{GO_AD_FREE_BLACK_DESCRIPTION_ENJOY}</span>
          </div>
          {!isStorypage && <div styleName="button-wrapper">
            <Button customStyleName="go-ad-free-btn-red" aria-label="go to ad free for Fortune India" href="/subscription">
              {GO_AD_FREE}
            </Button>
          </div>}
        </div>
      </a>
    </div>
  );
};

GoAdFreeWidgetRed.defaultProps = {
  customStyleName: "",
};
GoAdFreeWidgetRed.propTypes = {
  customStyleName: string,
};

export default GoAdFreeWidgetRed;
